/* ldp-sc1-m1.js — Spicy Cubes Early Black Friday landing page
   Countdown: fixed-duration countdown (NOT tied to system clock, no
   localStorage/cookie), always restarts at 00:05:23:49 on page load. */
var remaining=(0*86400+5*3600+23*60+49),cd=document.getElementById('cd');
function p(n){return String(n).padStart(2,'0')}
function tick(){
  var d=Math.floor(remaining/86400),h=Math.floor(remaining/3600)%24,m=Math.floor(remaining/60)%60,s=remaining%60;
  if(cd)cd.innerHTML='<span class="cd-u">'+p(d)+'</span><i class="cd-sep">:</i><span class="cd-u">'+p(h)+'</span><i class="cd-sep">:</i><span class="cd-u">'+p(m)+'</span><i class="cd-sep">:</i><span class="cd-u">'+p(s)+'</span>';
  if(remaining>0)remaining--;
}
tick();setInterval(tick,1000);

/* Hero parallax (desktop, pointer only) */
var sc=document.getElementById('scene');
if(sc&&matchMedia('(hover:hover) and (min-width:861px)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
  sc.parentElement.addEventListener('mousemove',function(e){var r=this.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
    sc.style.transform='rotateY('+(x*14)+'deg) rotateX('+(-y*10)+'deg)'});
  sc.parentElement.addEventListener('mouseleave',function(){sc.style.transform=''});
}

/* Sticky mobile CTA: show when hero CTA scrolls out of view, hide again once the offer section is reached */
var st=document.getElementById('sticky');
var heroCta=document.getElementById('cta');
if(st&&heroCta){new IntersectionObserver(function(en){st.classList.toggle('on',!en[0].isIntersecting)},{threshold:0}).observe(heroCta);}
var shopSection=document.getElementById('shop');
if(st&&shopSection){new IntersectionObserver(function(en){st.classList.toggle('off',en[0].isIntersecting)},{threshold:.15}).observe(shopSection);}

/* Offer bundle picker: updates the CTA label/price and carries the
   selected variant + quantity over to the Add to Cart + Buy now buttons */
var bc=document.getElementById('buyCta');
var bn=document.getElementById('buyNowCta');
function ldpPick(){
  var i=document.querySelector('.opt input:checked');
  if(!i||!bc)return;
  bc.textContent=(i.dataset.cta||'')+' · '+(i.dataset.price||'');
  bc.dataset.variantId=i.dataset.variantId||'';
  bc.dataset.qty=i.dataset.qty||'1';
  if(bn){bn.dataset.variantId=i.dataset.variantId||'';bn.dataset.qty=i.dataset.qty||'1';}
}
document.querySelectorAll('.opt input').forEach(function(o){o.addEventListener('change',ldpPick)});ldpPick();

/* Countdown mirror (buy box uses a compact ".cd2" copy of the top bar countdown) */
function ldpMirrorCountdown(){document.querySelectorAll('.cd2').forEach(function(e){if(cd)e.innerHTML=cd.innerHTML})}
ldpMirrorCountdown();setInterval(ldpMirrorCountdown,1000);

/* Real Shopify Add to Cart — bundle + gift line items, AJAX add, and
   opening the theme's existing Cart Drawer are all handled by
   sections/ldp-sc1-m1-offer.liquid's own inline script, using the exact
   same shared cart-drawer mechanism (window.__ebBeginCartAdd /
   window.__ebFinishCartAdd, from sections/cart-drawer-section.liquid) that
   landing-page-spicy-cubes' sections/scl-07-offer.liquid uses — covering
   both the main Add to Cart button (#buyCta) and the mobile sticky bar's
   button (#sticky [data-cta]). No new/duplicate Cart Drawer is created and
   no redirect to /cart happens on success. */

/* "Buy now" — adds to cart, then skips the cart entirely and goes straight
   to checkout (distinct from Add to Cart, which stays on-page/opens the drawer). */
function ldpBuyNow(e){
  var variantId=this.dataset.variantId;
  if(!variantId)return;
  e.preventDefault();
  var qty=parseInt(this.dataset.qty||'1',10)||1;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:variantId,quantity:qty}]})
  }).then(function(res){
    if(!res.ok)throw new Error('add-to-cart failed');
    return res.json();
  }).then(function(){
    window.location.href='/checkout';
  }).catch(function(){window.location.href='/cart'});
}
if(bn)bn.addEventListener('click',ldpBuyNow);

/* Reviews: show 3, reveal the rest on click */
var moreBtn=document.getElementById('moreReviews');
if(moreBtn){moreBtn.addEventListener('click',function(){
  document.querySelectorAll('.rv-hidden').forEach(function(c){c.classList.remove('rv-hidden')});
  moreBtn.style.display='none';
})}

/* Ingredients: tab selector shows exactly one detail panel at a time */
document.querySelectorAll('.ing-tab').forEach(function(tab){
  tab.addEventListener('click',function(){
    document.querySelectorAll('.ing-tab').forEach(function(t){t.classList.remove('active')});
    document.querySelectorAll('.ing-panel').forEach(function(p){p.classList.remove('active')});
    tab.classList.add('active');
    var target=document.getElementById(tab.dataset.target);
    if(target)target.classList.add('active');
  });
});

/* Nutrition overlay: open/close, no page redirect */
var nutriOverlay=document.getElementById('nutritionOverlay');
var nutriBtn=document.getElementById('viewNutritionBtn');
var nutriClose=document.getElementById('nutritionClose');
if(nutriBtn&&nutriOverlay){nutriBtn.addEventListener('click',function(){nutriOverlay.classList.add('open')});}
if(nutriClose&&nutriOverlay){nutriClose.addEventListener('click',function(){nutriOverlay.classList.remove('open')});}
if(nutriOverlay){
  nutriOverlay.addEventListener('click',function(e){if(e.target===nutriOverlay)nutriOverlay.classList.remove('open')});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')nutriOverlay.classList.remove('open')});
}

/* Offer product gallery: click a thumbnail to swap the hero image.
   Thumbnails + hero are rendered server-side from the linked Shopify
   product's media (or the gallery_image blocks when no product is linked). */
function ldpSwapImg(el,url){
  var hero=document.getElementById('pgHeroImg');
  if(hero)hero.src=url;
  document.querySelectorAll('#pgThumbs .pg-thumb').forEach(function(t){t.classList.remove('active')});
  el.classList.add('active');
}

/* Gal section — click-to-play video slots. Each slot's data-video-src
   (set from the block's "Video file URL" setting) is used to inject a
   playing <video> in place, with no page redirect. */
document.querySelectorAll('.video-slot').forEach(function(slot){
  slot.addEventListener('click',function(){
    var src=slot.getAttribute('data-video-src');
    if(!src)return;
    var v=document.createElement('video');
    v.src=src;v.controls=true;v.autoplay=true;v.playsInline=true;
    slot.innerHTML='';slot.appendChild(v);v.play();
  });
});
